import { getUrlLocale } from "../../utils/getUrlLocale";
export class GetLocationsByName {
    constructor() {
        this.getLocationsByName = async (name) => {
            var _a;
            (_a = GetLocationsByName.abortController) === null || _a === void 0 ? void 0 : _a.abort();
            GetLocationsByName.abortController = new AbortController();
            const apiUrl = process.env.REACT_APP_GATEWAY_API_URL || '';
            // WI #8320 — Use URL-derived locale (2-letter code, never country-tinged).
            // Previously: `(i18next.language || 'en').slice(0, 2)` could be contaminated
            // when the country selector flipped `i18next.language` to e.g. "es-DE".
            const language = getUrlLocale("lower").split("-")[0];
            try {
                const url = new URL(`/locations/autocomplete?input=${encodeURIComponent(name)}&language=${language}`, apiUrl);
                const response = await fetch(url.toString(), {
                    method: 'get',
                    signal: GetLocationsByName.abortController.signal,
                });
                const data = await response.json();
                return data;
            }
            catch (error) {
                if (error instanceof DOMException && error.name === 'AbortError') {
                    return [];
                }
                return console.error(error);
            }
        };
    }
}
GetLocationsByName.abortController = null;
export default GetLocationsByName;
